/**
 * Generates a unique identifier with an optional prefix.
 * @param prefix The prefix to be added to the generated identifier. Default is '_'.
 * @returns The unique identifier.
 */
export function uniqueId(prefix = '_') {
    return prefix + (Number(String(Math.random()).slice(2)) + Date.now()).toString(36);
}
